import FeatherIcon from "feather-icons-react";
import React from "react";
import { Link } from "react-router-dom";
import heroImg from "../assets/img/hero.jpeg";

function Home() {
  return (
    <div className="mt-3">
      <div className="container-fluid">
        <div className="px-4 pt-5 my-5">
          <h1 className="display-4 fw-bold text-center text-body-emphasis">
            Tools to Simplify Your Day
          </h1>
          <div className="col-lg-6 mx-auto">
            <p className="lead mb-4 text-center">
              Effortless solutions for your daily challenges—smarter, faster,
              and designed for everyone.
            </p>
            <div className="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
              <Link class="btn btn-dark px-4 me-sm-2" to="/tools" role="button">
                Try It Now{" "}
                <FeatherIcon
                  className="text-white h-75"
                  icon="arrow-up-right"
                />
              </Link>
              <Link type="button" className="btn btn-outline-dark px-4" to="/tools">
                Discover Free Tools
              </Link>
            </div>
          </div>
          <div className="overflow-hidden" style={{ maxHeight: "60vh" }}>
            <div className="text-center px-5">
              <img
                src={heroImg}
                alt="Hero"
                className="img-fluid border rounded-3 shadow-lg mb-4"
                loading="lazy"
                width={700}
                height={500}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
